export const STARTED = 'Iniciada'
export const SUSPENDED = 'Suspensa'
export const CONCLUDED = 'Concluída'
export const SCHEDULED = 'Prevista'

export const NPS_CAN_SUSPEND_STATUSES = [
  STARTED,
  SCHEDULED
]

export const NPS_STATUS_CHIP_PROPS = {
  [STARTED]: { color: 'amber-9' },
  [SUSPENDED]: { color: 'negative' },
  [CONCLUDED]: { color: 'positive' },
  [SCHEDULED]: { color: 'blue-grey-6' }
}

export const NPS_STATUS_FILTER_OPTIONS = [
  SCHEDULED,
  STARTED,
  SUSPENDED,
  CONCLUDED
]

export const PROMOTER = 'Promotor'
export const PASSIVE = 'Neutro'
export const DETRACTOR = 'Detrator'

export const NPS_CUSTOMER_CATEGORY_COLOR = {
  [PROMOTER]: { color: 'positive' },
  [PASSIVE]: { color: 'accent' },
  [DETRACTOR]: { color: 'negative' }
}

export const NPS_CUSTOMER_CATEGORY_FILTER_OPTIONS = [
  PROMOTER,
  PASSIVE,
  DETRACTOR
]

export const DEFAULT_NPS = {
  id: null,
  start_at: null,
  end_at: null,
  should_send_by_email: true,
  status: null,
  is_suspended: false,
  total_promoters: 0,
  total_detractors: 0,
  total_passives: 0,
  total_responses: 0,
  nps_score: null,
  classification_zone: null,
  percent_promoters: null,
  percent_passives: null,
  percent_detractors: null,
  score_count_1: null,
  score_count_2: null,
  score_count_3: null,
  score_count_4: null,
  score_count_5: null,
  score_count_6: null,
  score_count_7: null,
  score_count_8: null,
  score_count_9: null,
  score_count_10: null
}

export const DEFAULT_NPS_RESPONSE = {
  score: undefined,
  comment: ''
}

export const NPS_RESPONSE_BUTTONS_PROPS = [
  { value: 0, color: 'red-10' },
  { value: 1, color: 'red-10' },
  { value: 2, color: 'red-9' },
  { value: 3, color: 'red-8' },
  { value: 4, color: 'red-7' },
  { value: 5, color: 'red-6' },
  { value: 6, color: 'red-5' },
  { value: 7, color: 'amber-9' },
  { value: 8, color: 'amber-6' },
  { value: 9, color: 'green-7' },
  { value: 10, color: 'green-9' }
]
